import { Dictionary } from '../../types';

export default {
    locale: 'enUS',
    entries: {
        a: '2'
    }
} as Dictionary;
